import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default class UserBreadCrumbs extends Component {

  render() {
    const { email } = this.props;
    return (
      <nav>
        <div className="breadcrumbs">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
          </div>
          <div className="breadcrumb">
            <span>Update Profile</span>
          </div>
          { email &&
          <div className="breadcrumb">
            <span>{email}</span>
          </div>
          }
        </div>
      </nav>
    )
  }
}

UserBreadCrumbs.propTypes = {
  email: PropTypes.string
};
